if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.counterCurrent = this.querySelector('[data-media-modal-counter-current]');
        this.counterTotal = this.querySelector('[data-media-modal-counter-total]');
        this.dotsContainer = this.querySelector('[data-media-modal-dots]');
        this.scrollContainer = this.querySelector('[role="document"]');
        this.activeIndex = 0;

        const prevButton = this.querySelector('[data-media-modal-prev]');
        const nextButton = this.querySelector('[data-media-modal-next]');
        if (prevButton) prevButton.addEventListener('click', () => this.step(-1));
        if (nextButton) nextButton.addEventListener('click', () => this.step(1));

        if (this.scrollContainer) {
          this.touchStartX = null;
          this.scrollContainer.addEventListener(
            'touchstart',
            (event) => {
              this.touchStartX = event.touches[0].clientX;
            },
            { passive: true }
          );
          this.scrollContainer.addEventListener(
            'touchend',
            (event) => {
              if (this.touchStartX === null) return;
              const deltaX = event.changedTouches[0].clientX - this.touchStartX;
              this.touchStartX = null;
              if (Math.abs(deltaX) < 40) return;
              this.step(deltaX < 0 ? 1 : -1);
            },
            { passive: true }
          );
        }
      }

      hide() {

        this.querySelectorAll('deferred-media[loaded]').forEach((dm) => {
          dm.querySelectorAll(':scope > iframe, :scope > video, :scope > model-viewer').forEach((el) => el.remove());
          dm.removeAttribute('loaded');
        });
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        this.buildDots();
        this.showActiveMedia();
      }

      buildDots() {
        if (!this.dotsContainer || this.dotsBuilt) return;
        this.mediaItems.forEach((_item, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'gm-media-modal-dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `${index + 1} / ${this.mediaItems.length}`);
          dot.addEventListener('click', () => this.goToIndex(index));
          this.dotsContainer.appendChild(dot);
        });
        this.dotsBuilt = true;
        if (this.counterTotal) this.counterTotal.textContent = this.mediaItems.length;
      }

      indexOf(mediaId) {
        return this.mediaItems.findIndex((item) => item.getAttribute('data-media-id') === mediaId);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.setActiveIndex(this.indexOf(activeMedia.getAttribute('data-media-id')));
      }

      setActiveIndex(index) {
        if (index < 0) return;
        this.activeIndex = index;
        if (this.counterCurrent) this.counterCurrent.textContent = index + 1;
        if (this.dotsContainer) {
          Array.from(this.dotsContainer.children).forEach((dot, i) => {
            const isActive = i === index;
            dot.classList.toggle('gm-media-modal-dot--active', isActive);
            dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
        }
      }

      step(delta) {
        this.goToIndex(Math.min(Math.max(this.activeIndex + delta, 0), this.mediaItems.length - 1));
      }

      goToIndex(index) {
        const target = this.mediaItems[index];
        if (!target) return;
        this.mediaItems.forEach((item) => item.classList.remove('active'));
        target.classList.add('active');
        target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        this.setActiveIndex(index);
      }

    }
  );
}
